export default __webpack_public_path__ + "static/media/medium-workmark.ed9bc0d8.svg";